import { Paper, Center, Loader, Text } from "@mantine/core";

import { ListWorkOrderDto } from "../../models/workorder.models";
import { useGetWorkOrdersByLocationIdQuery } from "../../api/workorder.api";
import { WorkOrderListItem } from "../WorkOrders/WorkOrderListItem";

interface LocationWorkOrderListProps {
	locationId: string;
	onSelect?: (workOrder: ListWorkOrderDto) => void;
	selectedWorkOrderId?: string | null;
}

export const LocationWorkOrderList = ({ locationId, onSelect, selectedWorkOrderId }: LocationWorkOrderListProps) => {
	const { data: workOrders, isLoading } = useGetWorkOrdersByLocationIdQuery(locationId);

	const filteredWorkOrders = workOrders?.filter(workOrder => workOrder.Location.LocationId === locationId) || [];

	const sortedWorkOrders = filteredWorkOrders.sort((a, b) => new Date(b.Created).getTime() - new Date(a.Created).getTime());

	if (isLoading) return <>
		<Center>
			<Loader size="sm" mt="lg" />
		</Center>
	</>;

	if (!filteredWorkOrders.length) return <Text c="dimmed">No work orders for this location.</Text>;

	return (
		<Paper p={0} radius="md" style={{ overflow: 'hidden' }}>
			{sortedWorkOrders.map(workOrder => (
				<WorkOrderListItem
					key={workOrder.WorkOrderId}
					workOrder={workOrder}
					selected={selectedWorkOrderId === workOrder.WorkOrderId}
					onSelect={onSelect ? onSelect : () => { }}
					showCategories={true}
				/>
			))}
		</Paper>
	);
};
